import {
  Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, AfterContentInit,
  OnInit, ElementRef
} from "@angular/core";

@Component({
  selector: 'widget-input',
  template: `<div
                [formGroup]="form"
                [class.has-error]="form.controls[id].touched && !form.controls[id].valid"
                [class.has-feedback]="form.controls[id].touched && !form.controls[id].valid">
                <label class="control-label text-right {{labelClass}}" for="{{id}}" [class.active]="model">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  <input type="{{type}}" id="{{id}}" class="form-control validate" maxlength="{{maxlength}}"
                         [(ngModel)]="model"
                         formControlName="{{id}}"
                         (change)="update($event.target.value)"
                         [class.input-view]="readonly"
                         [readonly]="readonly"
                         [tipoTexto]="tipoTexto"
                         [textMask]="{mask: mascara}">
                  <div class="form-control-feedback" *ngIf="form.controls[id].touched && !form.controls[id].valid">
                    <i class="icon-cancel-circle2"></i>
                  </div>
                  <span class="help-block" *ngIf="form.controls[id].touched && !form.controls[id].valid && !form.controls[id].errors[id]">{{txt_default_erro}}</span>
                  <div *ngIf="!form.controls[id].valid">
                    <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                  </div>
                </div>
              </div>`,
})

export class WidgetInputComponent implements OnInit {

  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  readonly: boolean = false;

  @Input()
  upperCase: boolean = false;

  @Input()
  lowerCase: boolean = false;

  @Input()
  maxlength: any = null;

  @Input()
  type: string = 'text';

  @Input()
  mascara: any = false;

  @Input()
  isNumber: boolean = false;

  tipoTexto: string;


  ngOnInit(): void {
    if(this.upperCase){
      this.tipoTexto = 'upperCase';
    }
    if(this.lowerCase){
      this.tipoTexto = 'lowerCase';
    }
    if(this.isNumber){
      this.tipoTexto = 'number';
    }
  }

  update(val : string) {
    if (this.id && this.id.startsWith('tamanho_calibre_') && typeof val === 'string') {
      val = val.replace(/,/g, '.');
      if (this.form && this.form.controls[this.id]) {
        this.form.controls[this.id].setValue(val, { emitEvent: false });
      }
    }
    this.model = val;
    this.modelChange.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-input.component.ts